// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"87":"58e7e803f8327c9aed77","276":"6e512f2148e3700c1b7d","317":"3a7d01ec34530f60c7e9","356":"36e3380ecfcf5cc33b75","401":"8a8df9324431d3aae256","439":"610abf0e858641404645","700":"fe4d7c9df4e16a067124","810":"e848c707969238f3a95e","975":"ea92958f7acf21a74fc4"}[chunkId] + ".js";
};